import React, { useEffect } from 'react';
import DronesSidebar from './drones';
import { useDispatch } from 'react-redux';
import { resetState } from '@src/features/drone/redux';

export const Sidebars: React.FC = () => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    return () => {
      dispatch(resetState());
    };
  }, []);

  return <DronesSidebar />;
};